import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createContext } from 'react';

export const AppInsightsInstanceContext = createContext<
  ApplicationInsights | undefined
>(undefined);
AppInsightsInstanceContext.displayName = 'AppInsightsInstanceContext';
